import { Navigate, Outlet, useLocation } from 'react-router';
import { useSessionState } from '../../auth/use-session';

/**
 * The gate in front of every authenticated screen (docs/07-implementation-roadmap.md
 * F1.4).
 *
 * **The attempted path is kept.** A coordinator following a link to a member
 * record with an expired session should land on that record after signing in,
 * not on the dashboard having lost what they were doing. The path travels in
 * router state rather than in the query string: it is nobody's business but this
 * browser's, and a `?next=` parameter is an open redirect waiting to be pointed
 * at another host.
 *
 * `status === 'unknown'` cannot reach here — `SessionProvider` holds the tree
 * until the boot restore has answered — so there are only two cases.
 */
export function RequireAuth() {
  const { status } = useSessionState();
  const location = useLocation();

  if (status !== 'authenticated') {
    return <Navigate to="/masuk" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}
